import { render, staticRenderFns } from "./UserRegistrationCard.vue?vue&type=template&id=36be1ddd&scoped=true&"
import script from "./UserRegistrationCard.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be1ddd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/bikrampahi/Projects/upwork/5 Brian/sndle.io/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VForm,VSpacer,VTextField,VToolbar,VToolbarTitle})
